import { render, staticRenderFns } from "./VenuePanicTable.vue?vue&type=template&id=23898404"
import script from "./VenuePanicTable.vue?vue&type=script&lang=ts"
export * from "./VenuePanicTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports